import React from 'react';
import { useRecoilState, useSetRecoilState } from 'recoil';
import * as AppState from '../../../../AppState';
import ButtonGroup from '../../../Shared/ButtonGroup/ButtonGroup';
import { FilterOption } from '../../../../interfaces/filters';

export const bedFilterOptions: FilterOption[] = [
	{
		label: 'Any',
		value: 0
	},
	{
		label: '1+',
		value: 1
	},
	{
		label: '2+',
		value: 2
	},
	{
		label: '3+',
		value: 3
	},
	{
		label: '4+',
		value: 4
	},
	{
		label: '5+',
		value: 5
	}
];
export const bathFilterOptions: FilterOption[] = [
	{
		label: 'Any',
		value: 0
	},
	{
		label: '1+',
		value: 1
	},
	{
		label: '1.5+',
		value: 1.5
	},
	{
		label: '2+',
		value: 2
	},
	{
		label: '3+',
		value: 3
	},
	{
		label: '4+',
		value: 4
	}
];

const BedsAndBaths = () => {
	const setGsBedsFilterApplied = useSetRecoilState(AppState.gsBedsFilterApplied);
	const setGsBathsFilterApplied = useSetRecoilState(AppState.gsBathsFilterApplied);
	const [gsFilters, setGsFilters] = useRecoilState(AppState.gsFilters);

	const activeBedsButton = () => {
		const index = bedFilterOptions.findIndex(filterOption => gsFilters.bedroomsMin === filterOption.value);
		if (index !== -1)
			return index;
		else return 0;
	};
	const activeBathsButton = () => {
		const index = bathFilterOptions.findIndex(filterOption => gsFilters.bathroomsMin === filterOption.value);
		if (index !== -1)
			return index;
		else return 0;
	};


	React.useEffect(() => {
		// Highlights dropdown button if either filter is active
		if (gsFilters.bedroomsMin !== 0) {
			setGsBedsFilterApplied(true);
		} else setGsBedsFilterApplied(false);

		if (gsFilters.bathroomsMin !== 0) {
			setGsBathsFilterApplied(true);
		} else setGsBathsFilterApplied(false);
	}, [gsFilters.bedroomsMin, gsFilters.bathroomsMin, setGsBedsFilterApplied, setGsBathsFilterApplied]);

	return (
		<div className="pb-2">
			<div className="mb-3">
				<ButtonGroup
					id="bedroomsButtonGroup"
					label="Bedrooms"
					wrapperClass="w-100"
					options={bedFilterOptions}
					callback={
						(label: string, index: number, option: FilterOption) =>
							setGsFilters(currVal => ({ ...currVal, bedroomsMin: option.value ?? 0 }))
					}
					activeButton={activeBedsButton()}
				/>
			</div>
			<ButtonGroup
				id="bathroomsButtonGroup"
				label="Bathrooms"
				wrapperClass="w-100"
				options={bathFilterOptions}
				callback={
					(label: string, index: number, option: FilterOption) =>
						setGsFilters(currVal => ({ ...currVal, bathroomsMin: option.value ?? 0 }))
				}
				activeButton={activeBathsButton()}
			/>
		</div>
	);
};

export default BedsAndBaths;
